import React, { useCallback, useEffect, useState } from "react";
import Select from "react-select";
import {
  delete_icon,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import { deletes, get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation, useNavigate } from "react-router-dom";
import { Table } from "../../components/Table/Table";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";
import moment from "moment";

function UserList() {
  const LOCATION_TYPES = {
    STATE: 2,
    CITY: 3,
    AREA: 4,
  };

  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname, state } = useLocation();
  const path = pathname?.replace("/", "");

  const navigate = useNavigate();
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });

  console.log("paginationData", paginationData);

  const [popup, setPopup] = useState({ isvalue: false, des: "" });
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [dateFilterKey, setDateFilterKey] = useState("created_at");
  console.log("page", page);
  const [deleteConfirm, setDeleteConfirm] = useState({
    open: false,
    id: null,
  });

  const [selectedFilter, setSelectedFilter] = useState({
    from: moment().format("YYYY-MM-DD"),
    to: moment().format("YYYY-MM-DD"),
  });
  const [totalCount, setTotalCount] = useState(0);
  let tab = JSON.parse(localStorage.getItem("tab"));
  const [activeStatus, setActiveStatus] = useState(tab ?? "send");

  console.log("activeStatus", activeStatus);

  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [list, setList] = useState({
    send: [],
    sent: [],
  });
  const [locationList, setLocationsList] = useState({
    states: [],
    cities: [],
    areas: [],
  });
  const listPart = ["send", "sent"];
  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  const getSelectedIds = () =>
    list[activeStatus].filter((item) => item.selected).map((item) => item.id);

  const handleSendNotifications = async (id) => {
    const payload = {
      notification_ids: [id],
    };

    const res = await post(URLS.SEND_NOTIFICATIONS, payload);
    if (res?.status == "success") {
      toast.success(res?.message);
      notificationData(page);
    }
  };

  const getLocationsList = useCallback(async (locationType, parent_id) => {
    try {
      const url = `${URLS.LOCATION}?type=${locationType}${
        parent_id ? "&parent_id=" + parent_id : ""
      }`;
      const res = await get(url);

      if (res?.status === "success") {
        const result = res.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        if (locationType === LOCATION_TYPES.STATE) {
          setLocationsList((prev) => ({ ...prev, states: result }));
        } else if (locationType === LOCATION_TYPES.CITY) {
          setLocationsList((prev) => ({ ...prev, cities: result }));
        } else if (locationType === LOCATION_TYPES.AREA) {
          setLocationsList((prev) => ({ ...prev, areas: result }));
        }
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  }, []);
  const getUserIdList = useCallback(async () => {
    try {
      const res = await get(URLS.USERLIST_DROPDOWN);

      if (res?.status === "success") {
        const result = res.data.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setSelectedUser(result);
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  }, []);
  useEffect(() => {
    setpaginationData((prev) => ({
      ...prev,
      [path]: {
        ...prev?.[path],
        page: page,
      },
    }));
    getLocationsList(LOCATION_TYPES.STATE);
  }, [page]);

  useEffect(() => {
    if (selectedFilter?.state?.value) {
      getLocationsList(LOCATION_TYPES.CITY, selectedFilter.state.value);
    }
  }, [selectedFilter?.state]);

  console.log("list_Notificatio", list);

  const renderListCell = (items) => {
    if (!items || items.length === 0) return "-";
    if (items.length <= 2) return <p>{items.join(", ")}</p>;

    const displayItems = items.slice(0, 2).join(", ");
    const hiddenItems = items.slice(2);
    // console.log(hiddenItems, "hiddenItems");
    return (
      <>
        <div className="d-flex align-items-center ">
          <p>
            {displayItems} +{" "}
            {Array.isArray(hiddenItems)
              ? hiddenItems.length > 0
                ? hiddenItems.length
                : ""
              : ""}
          </p>
          {/* <OverlayTrigger
            placement="top"
            overlay={(props) => renderTooltip(props, hiddenItems)}
          >
            <RemoveRedEyeIcon
              className="ms-2 cursor-pointer text-primary"
              style={{ fontSize: "18px" }}
            />
          </OverlayTrigger> */}
        </div>
      </>
    );
  };

  const handleDeleteClick = (id) => {
    if (!checkPermission("CAN-DELETE-ADMIN_ROLES")) return;
    setDeleteConfirm({ open: true, id });
  };

  const handleDeleteConfirm = async () => {
    const { id } = deleteConfirm;
    setDeleteConfirm({ open: false, id: null }); // close modal first

    let res = await deletes(`${URLS.NOTIFICATION_SEND_DELETE}${id}/delete/`);
    if (res?.status === "success") {
      toast.success("Notification Deleted Successfully");
      notificationData();
    }
  };

  const handleDeleteCancel = () => {
    setDeleteConfirm({ open: false, id: null });
  };
  const handleCreateAtChange = () => {
    setDateFilterKey("created_at");
  };

  const handleUpdateAtChange = () => {
    setDateFilterKey("updated_at");
  };
  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },

      {
        Header: "State",
        accessor: "states",
        Cell: ({ value }) => renderListCell(value),
      },
      {
        Header: "City",
        accessor: "cities",
        Cell: ({ value }) => renderListCell(value),
      },

      {
        Header: "User /Group User",
        accessor: "users",
        Cell: ({ value }) => renderListCell(value),
      },
      {
        Header: "Created On",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p>{value && moment(value).format("DD-MM-YYYY")}</p>;
        },
      },
    ];
    let desc = {
      Header: "Description",
      accessor: "user_state",
      Cell: ({ value, row }) => {
        return (
          <div onClick={() => setPopup({ isvalue: true, des: row.original })}>
            <img src={view_icon} alt="" className=" edit-btn " />
          </div>
        );
      },
    };
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        let show = activeStatus == "send";
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              {show && (
                <button
                  style={{ width: 198, padding: "5px" }}
                  onClick={() => handleSendNotifications(row?.original?.id)}
                  className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
                  // style={{  }}
                >
                  Send Notification
                </button>
              )}

              {show && (
                <>
                  {checkPermission("CAN-EDIT-NOTIFICATION") && (
                    <button
                      onClick={() => {
                        navigate("/user-notification-add", {
                          state: {
                            type: "edit",
                            data: row.original,
                            page: page,
                          },
                        });
                      }}
                      className="cust-btn "
                    >
                      <img src={edit_icon} alt="" className=" edit-btn " />
                    </button>
                  )}
                  {checkPermission("CAN-DELETE-NOTIFICATION") && (
                    <button
                      onClick={() => handleDeleteClick(row.original.id)}
                      className="cust-btn "
                    >
                      <img src={delete_icon} alt="" className=" edit-btn " />
                    </button>
                  )}
                </>
              )}
              {checkPermission("CAN-VIEW-NOTIFICATION") && (
                <button
                  onClick={() => {
                    navigate("/user-notification-add", {
                      state: { type: "view", data: row.original, page: page },
                    });
                  }}
                  className="cust-btn "
                >
                  <img src={view_icon} alt="" className=" edit-btn " />
                </button>
              )}
              {/* {checkPermission("CAN-VIEW-NOTIFICATION") ? "" : "-"} */}
            </div>
          </React.Fragment>
        );
      },
    };
    d = checkPermission("CAN-VIEW-NOTIFICATION") ? [...d, desc] : d;
    return checkPermission("CAN-EDIT-NOTIFICATION") ||
      checkPermission("CAN-DELETE-NOTIFICATION")
      ? [...d, action]
      : d;
  }, [page, activeStatus, list]);
  console.log("popup?.isvalue", popup);
  const notificationData = async (pageNumber = page) => {
    const payload = {
      state_ids: selectedFilter?.state?.value,
      city_ids: selectedFilter?.city?.value,
      user_ids: selectedFilter?.user?.value,

      search: selectedFilter?.search || "",
      notification_status: activeStatus == "send" ? 1 : 2,
    };
    if (selectedFilter?.from && selectedFilter?.to) {
      payload.from_date = moment(selectedFilter?.from).format("YYYY-MM-DD");

      payload.to_date = moment(selectedFilter?.to).format("YYYY-MM-DD");
    }
    payload.date_filter_key = dateFilterKey;
    let url = `${URLS.USERNOTIFICATION_DATA}?page=${pageNumber}`;
    const res = await post(url, payload);
    if (res?.status === "success") {
      const updatedData = res.data.map((item) => ({
        ...item,
        selected: false,
      }));

      setList((prev) => ({
        ...prev,
        [activeStatus]: updatedData,
      }));

      // 👇 ADD THIS LINE to reset the "Select All" checkbox state
      setIsSelectAll(false);

      setTotalCount(res?.count);

      setPagination({ current_page: pageNumber, last_page: res?.total_pages });
    }
  };
  useEffect(() => {
    getUserIdList();
    notificationData(page);
  }, [page, selectedFilter, activeStatus, dateFilterKey]);
  console.log("selectedFilter", selectedFilter);
  useEffect(() => {
    setSelectedFilter({
      from: moment().format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD"),
    });
  }, []);

  return (
    <div>
      <Topbar header={"UserList"} />
      <div className="d-flex ac-jb mt-3 gap-4 flex-wrap">
        <div className="d-flex ac-js mt-3 gap-4 flex-wrap">
          <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
            Total:{totalCount}
          </h2>
          {listPart?.map((item, i) => (
            <button
              key={i}
              onClick={() => {
                // setPage(1);
                // handleChangeFilter("from", "");
                // handleChangeFilter("to", "");
                setActiveStatus(item);
                localStorage.setItem("tab", JSON.stringify(item));
                setPage(1);
                setIsSelectAll(false);
              }}
              className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                activeStatus === item ? "active-btn1" : "inactive-btn"
              }`}
            >
              {item}
            </button>
          ))}
        </div>

        <div className="d-flex ac-js mt-3 gap-4 flex-wrap">
          {activeStatus === "sent" && (
            <div style={{ flexDirection: "column", gap: 90 }}>
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <input
                    type="checkbox"
                    checked={dateFilterKey === "created_at"}
                    onChange={handleCreateAtChange}
                    style={{ width: 20, height: 20 }}
                  />
                  <p className="mb-0">Create At</p>
                </div>
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <input
                    type="checkbox"
                    checked={dateFilterKey === "updated_at"}
                    onChange={handleUpdateAtChange}
                    style={{ width: 20, height: 20 }}
                  />
                  <p className="mb-0">Update At</p>
                </div>
              </div>

              <DateRange
                fromValue={selectedFilter.from}
                toValue={selectedFilter.to}
                setFromDate={(date) => {
                  handleChangeFilter("from", date);
                }}
                setToDate={(date) => {
                  handleChangeFilter("to", date);
                }}
              />
            </div>
          )}
          {checkPermission("CAN-ADD-NOTIFICATION") && (
            <button
              style={{ width: 152 }}
              // onClick={handleAddCoupon}
              onClick={() =>
                navigate("/user-notification-add", { state: { page: page } })
              }
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
            >
              + Add New
            </button>
          )}
        </div>
      </div>
      {/* Filter Start */}
      <div className="d-flex ac-jb mt-3 gap-1 flex-wrap">
        <Select
          className="location-search"
          options={locationList?.states}
          placeholder={"State"}
          isClearable
          onChange={(e) => {
            handleChangeFilter("state", e);
          }}
          value={selectedFilter?.state}
        />
        <Select
          className="location-search"
          options={locationList?.cities}
          placeholder={"City"}
          isClearable
          onChange={(e) => {
            handleChangeFilter("city", e);
          }}
          value={selectedFilter?.city}
        />
        <Select
          className="location-search"
          options={selectedUser}
          placeholder={"User ID"}
          isClearable
          onChange={(e) => {
            handleChangeFilter("user", e);
          }}
          value={selectedFilter?.user}
        />
        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search Description"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img alt="" src={Search_icon} className="search" />
        </div>

        {/* commenting to remove multiple select option */}

        {/* {activeStatus == "send" && (
          <div className="d-flex ac-js gap-2 align-items-center">
            <input
              type="checkbox"
              checked={isSelectAll}
              onChange={handleSelectAll}
              style={{ width: "18px", height: "18px" }}
            />
            <button
              className="f2 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14 white add-btn"
              style={{
                backgroundColor: "#E69B3D",
                border: "none",
                padding: "8px 15px",
              }}
              onClick={handleSelectAll}
            >
              Select All
            </button>
            {isSelectAll && (
              <button
                className="f2 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14 add-btn"
                style={{
                  backgroundColor: "transparent",
                  border: "1px solid #4CAF50",
                  color: "#4CAF50",
                  padding: "8px 15px",
                }}
                onClick={() => handleSendNotifications()}
              >
                Send Notification All
              </button>
            )}
          </div>
        )} */}
      </div>
      {/* Filter end */}
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list[activeStatus]}
        show={true}
      />

      {popup?.isvalue && (
        <div className="img-popup-design">
          <div className="img-popup" style={{ position: "relative" }}>
            <h3 style={{ textAlign: "left", marginBottom: "20px" }}>
              Description
            </h3>
            <div
              style={{
                border: "1px solid #000",
                borderRadius: "10px",
                padding: "10px",
                display: "flex",
                justifyContent: "left",
                alignItems: "flex-start",
              }}
            >
              <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15">
                {popup?.des?.description}
              </p>
            </div>
            <div
              className="d-flex ac-jb px-2 mt-5"
              style={{ position: "absolute", top: -40, right: 0 }}
            >
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                // className="back-btn f2 w-40"
                style={{
                  border: "none",
                  background: "#fff",
                  // border: "1px solid #000",
                  borderRadius: "30px",
                  width: "25px",
                  height: "25px",
                  marginBottom: "20px",
                  padding: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                X
              </button>
            </div>
          </div>
        </div>
      )}
      {deleteConfirm.open && (
        <div className="img-popup-design">
          <div className="img-popup">
            <h2 className="f4 ms-2 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-16 fs-md-18 fs-lg-18 fs-xl-18 fs-xxl-18 mt-4">
              Delete Notification
            </h2>
            <p className="f3 ms-2 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure you want to delete this Notification? This action
              cannot be undone.
            </p>
            <div
              className="flex gap-3"
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "center",
                marginTop: 10,
              }}
            >
              <button onClick={handleDeleteCancel} className="back-btn f2 w-10">
                No, Cancel
              </button>
              <button onClick={handleDeleteConfirm} className="add-btn w-30">
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserList;
